import React, { useState } from "react"
import { Link } from "gatsby"
import { Formik, Field, Form, ErrorMessage } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { navigate } from "gatsby"
import ReCAPTCHA from "react-google-recaptcha"

import Logo from "../../BrandLogo"
import { footerLogos, footerSocials } from "./footerData"
import Button from "../../Button"

import "./footer.css"

const Footer = ({ className = "", languagePreference }) => {
  const [isActive, setActive] = useState(false)
  const [isVerified, setIsVerified] = useState(false);

  const handleRecaptchaVerify = () => {
    setIsVerified(true);
  };

  const languageSelected = languagePreference ? languagePreference.toLowerCase() : null;

  return (
    <footer className={`py-80 px-20 overflow-hidden ${className}`}>
      <div className="container grid col-3 gap-35 mx-auto col-1-md">
        <div id="footer-left" className="flex flex-col gap-10 align-center">
          <div className="mb-30">
            <Logo href="/" title="Savor Brands Logo" isDarkMode={true} />
          </div>
          <div className="grid col-2 gap-20 col-1-md mx-auto">
            <div
              id="social-links"
              className="flex gap-5 align-center justify-center"
            >
              {footerSocials.map((social, index) => ( 
                <a key={index} href={social.link} title={social.name} target="_blank" rel="nofollow noopener noreferrer">
                  <img src={social.svg} className="ma-0 footer-icon" alt={social.name || `Social Logo ${index}`} />
                </a>
              ))}
            </div>
            <div
              id="footer-logos"
              className="flex gap-5 align-center justify-center"
            >
              {footerLogos.map((item, index) => (
                <a key={index} href={item.link} title={item.name} target="_blank" rel="nofollow noopener noreferrer">
                  <img src={item.src} className="ma-0" alt={item.name || `Logo ${index}`} />
                </a>
              ))}
            </div>
          </div>
          <div>
            <small className="text-12 text-center block max-w-325-md">
              {languageSelected === 'spanish' 
              ? 'Savor Brands es un MSP/ISO registrado de Elavon, Inc., Georgia [una subsidiaria de propiedad total de U.S. Bancorp, Minneapolis, MN]'
              : languageSelected === 'portuguese' 
              ? 'Savor Brands é um MSP/ISO registrado da Elavon, Inc., Geórgia [uma subsidiária integral do U.S. Bancorp, Minneapolis, MN]'
              : languageSelected === 'arabic' 
              ? 'سافور براندز هي مزود مسجل للخدمات (MSP/ISO) لشركة إلافون، إنك، جورجيا [شركة تابعة بالكامل لشركة يو إس بانكورب، مينابوليس، مينيسوتا]'
              : languageSelected === 'german' 
              ? 'Savor Brands ist ein registrierter MSP/ISO von Elavon, Inc., Georgia [eine hundertprozentige Tochtergesellschaft von U.S. Bancorp, Minneapolis, MN]'
              : languageSelected === 'italian' 
              ? 'Savor Brands è un MSP/ISO registrato di Elavon, Inc., Georgia [una consociata interamente controllata di U.S. Bancorp, Minneapolis, MN]'
              : languageSelected === 'japanese'
              ? 'Savor Brandsは、Elavon, Inc.（ジョージア州、U.S. Bancorp［ミネソタ州ミネアポリス］の完全子会社）の登録MSP/ISOです。'
              : languageSelected === 'french' 
              ? "Savor Brands est un MSP/ISO enregistré d'Elavon, Inc., Géorgie [une filiale en propriété exclusive de U.S. Bancorp]."
              : languageSelected === 'indian - hindi' 
              ? "सेवर ब्रांड्स, एलावन इंक., जॉर्जिया (जो यू.एस. बैनकॉर्प, मिनियापोलिस, एमएन की पूर्ण स्वामित्व वाली सहायक कंपनी है) का एक पंजीकृत एमएसपी/आईएसओ है।"
              : 'Savor Brands is a Registered MSP/ISO of Elavon, Inc., Georgia [a wholly owned subsidiary of U.S. Bancorp, Minneapolis, MN]'
              }
            </small>
          </div>
        </div>
        <div id="footer-center" className="flex flex-flow-rw text-14">
          <div className="flex flex-col gap-10 justify-start align-items mx-auto">
            <div id="footer-links">
              <a href="/contact/" className="block py-5">
                {languageSelected === 'spanish'
                ? 'CONTACTO'
                : languageSelected === 'portuguese'
                ? 'CONTATO'
                : languageSelected === 'arabic'
                ? 'تواصل'
                : languageSelected === 'german' 
                ? 'Kontakt'
                : languageSelected === 'italian' 
                ? 'Contatti'
                : languageSelected === 'japanese'
                ? 'お問い合わせ'
                : languageSelected === 'indian - hindi' 
                ? "संपर्क करें"
                : 'CONTACT'}
              </a>
              <a href="mailto:HELLO@SAVORBRANDS.COM" className="block py-5">
                HELLO@SAVORBRANDS.COM
              </a>
            </div>
            <div
              id="footer-addresses"
              className="flex flex-col gap-10 justify-center align-items"
            >
              <address className="py-5 font-style-normal">
                707 RICHARDS ST, SUITE 405
                <br />
                HONOLULU, HAWAII 96813
              </address>
              <a href="tel:808-599-8988" className="block py-5">
                (808) 599-8988
              </a>
              <address className="py-5 font-style-normal">
                EDIFICIO INSIGNE 804
                <br />
                COL. SAN BENITO, S.S. EL SALVADOR.
              </address>
            </div>
            <Link to="/privacy-policy/">
              {languageSelected === 'spanish'
              ? 'Política de Privacidad'
              : languageSelected === 'portuguese'
              ? 'Política de Privacidade'
              : languageSelected === 'arabic'
              ? 'سياسة الخصوصية'
              : languageSelected === 'german' 
              ? 'Datenschutzrichtlinie'
              : languageSelected === 'italian' 
              ? 'Informativa sulla Privacy'
              : languageSelected === 'japanese/'
              ? 'プライバシーポリシー'
              : languageSelected === 'french' 
              ? 'Politique de confidentialité'
              : languageSelected === 'indian - hindi' 
              ? "गोपनीयता नीति"
              : 'Privacy Policy'}
            </Link>
            <Link to="/es/">Español</Link>
          </div>
        </div>
        <div>
          <div id="footer-right" className="text-center-md">
            <div className="newsletter-wrap">
                <p className="mt-0 mb-0 bold uppercase">
                  {languageSelected === 'spanish'
                  ? 'Registro para el Boletín'
                  : languageSelected === 'portuguese'
                  ? 'Inscrição na Newsletter'
                  : languageSelected === 'arabic'
                  ? 'الاشتراك في النشرة الإخبارية'
                  : languageSelected === 'german' 
                  ? 'Newsletter Anmeldung'
                  : languageSelected === 'italian' 
                  ? 'Iscrizione alla Newsletter'
                  : languageSelected === 'french' 
                  ? 'Inscription à la newsletter'
                  : languageSelected === 'indian - hindi' 
                  ? "न्यूज़लेटर साइनअप"
                  : 'Newsletter Signup'}
                </p>
                <Formik
                  initialValues={{ name: '', email: '' }}
                  validationSchema={Yup.object({
                      name: Yup.string().required('Required'),
                      email: Yup.string().email('Invalid email address').required('Required'),
                  })}
                  onSubmit={async (values, { resetForm, setSubmitting }) => {
                      try {
                        setActive(true)
                        if (isVerified) {
                          const requestData = {
                            name: values.name,
                            email: values.email
                          }
                          await axios.post("https://l2w58aj4ik.execute-api.us-west-2.amazonaws.com/production/sendnewsletter", requestData);
                          navigate('/thank-you/');
                          resetForm();
                          setActive(false)
                        }
                      } catch (error) {
                          alert("Form submission failed. Please try again.");
                      }
                  }}
                  >
                    <Form className="mt-10">
                      <div className="form-field">
                        <Field name="name" type="text" placeholder={
                          languageSelected === 'spanish' 
                            ? 'Nombre' : languageSelected === 'portuguese' 
                              ? 'Nome' : languageSelected === 'arabic' 
                                ? 'الاسم' : languageSelected === 'german' 
                                  ? 'Name' : languageSelected === 'italian' 
                                    ? 'Nome' : languageSelected === 'japanese'
                                      ? '名前' : languageSelected === 'french' 
                                        ? 'Nom' : languageSelected === 'indian - hindi' 
                                          ? "नाम" : 'Name'} />
                        <ErrorMessage className="error" name="name" component="div" />
                      </div>
                      <div className="form-field">
                        <Field name="email" type="email" placeholder={
                          languageSelected === 'spanish' 
                            ? 'Correo Electrónico' : languageSelected === 'portuguese' 
                              ? 'E-Mail' : languageSelected === 'arabic' 
                                ? 'البريد الإلكتروني' : languageSelected === 'german' 
                                  ? 'E-Mail' : languageSelected === 'italian' 
                                    ? 'Email' : languageSelected === 'japanese'
                                      ? 'メール' : languageSelected === 'french'
                                        ? 'E-mail' : languageSelected === 'indian - hindi' 
                                          ? "ईमेल" : 'Email'} />
                        <ErrorMessage className="error" name="email" component="div" />
                      </div>
                      <div className="relative">
                        <div id="html_element"></div>
                        <div className="recaptcha">
                          <ReCAPTCHA
                            sitekey="6Lc8IDwpAAAAANc5Pbpv-6wQd5bbQT6EPUdcsrJx"
                            onChange={handleRecaptchaVerify}
                          />
                        </div>
                      </div>
                      <div className="mt-10">
                        <Button type="submit" classNameVal={`w-full bold ${!isVerified || isActive ? 'btn--disabled' : ''}`} text={
                          languageSelected === 'spanish' 
                            ? 'REGÍSTRATE' : languageSelected === 'portuguese' 
                              ? 'INSCREVA-SE' : languageSelected === 'arabic' 
                                ? 'اشترك' : languageSelected === 'german' 
                                  ? 'ANMELDEN' : languageSelected === 'italian' 
                                    ? 'Iscriviti' : languageSelected === 'japanese'
                                      ? 'サインアップ' : languageSelected === 'french' 
                                        ? "S'INSCRIRE" : languageSelected === 'indian - hindi' 
                                          ? "साइन अप करें" : 'SIGN UP'} />
                      </div>
                    </Form>
                </Formik>
              </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer